import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// SessionContextProvider eliminado - usamos AuthContext custom para evitar conflictos
import LoadingScreen from './components/common/LoadingScreen';
import './i18n';
// Interceptor para suprimir errores de conexión
import './utils/errorInterceptor';
// Error buffer for report context capture
import { initErrorBuffer } from './utils/errorBuffer';

// Initialize error capture before rendering so we catch early errors
initErrorBuffer();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<LoadingScreen />}>
      <App />
    </React.Suspense>
  </React.StrictMode>
);
